// components/AnalysisSection2.jsx
import React from "react";
import "../tutorRegistration/TutorRegistration.css"; // Using existing parent CSS

const AnalysisSection2 = () => {
  // Sample ranking data - you can make this dynamic based on user data
  const rankings = [
    {
      position: 1,
      name: "Dr. Aisha Bello",
      points: 12500,
      avatar: "../images/avatar.png",
    },
    {
      position: 2,
      name: "Prof. Chinedu Okeke",
      points: 11850,
      avatar: "../images/avatar.png",
    },
    {
      position: 3,
      name: "Mr. Fatima Yusuf",
      points: 9800,
      avatar: "../images/avatar.png",
    },
    // ... more rankings
    {
      position: 3001,
      name: "John Doe (You)",
      points: 2500,
      avatar: "../images/card-avatar.png",
      isCurrentUser: true,
    },
  ];

  return (
    <div className="analysis-section">
      <div className="analysis-container">
        <div className="chart-overlap">
          {/* Leadership Ranking Card replacing area-card */}
          <div className="analysis-card leadership-card">
            <div className="leadership-header">
              <img
                src="../images/crown.png"
                alt="Leadership"
                className="leadership-logo"
              />
              <div className="leadership-chart-title">Tutor Leadership Ranking</div>
            </div>
            <div className="ranking-container">
              {rankings.slice(0, 5).map((tutor, index) => (
                <div
                  key={index}
                  className={`ranking-item ${
                    tutor.isCurrentUser ? "current-user" : ""
                  }`}
                >
                  <span className="rank-position">#{tutor.position}</span>
                  <div className="rank-user-info">
                    <img
                      src={tutor.avatar}
                      alt={tutor.name}
                      className="rank-avatar"
                    />
                    <span className="rank-name">{tutor.name}</span>
                  </div>
                  <span className="rank-points">{tutor.points} pts</span>
                </div>
              ))}
              {/* Show current user position if not in top 5 */}
              {rankings.find((t) => t.isCurrentUser)?.position > 5 && (
                <div className="your-ranking-highlight">
                  <div className="ranking-item current-user">
                    <span className="rank-position">
                      #{rankings.find((t) => t.isCurrentUser)?.position}
                    </span>
                    <div className="rank-user-info">
                      <img
                        src={rankings.find((t) => t.isCurrentUser)?.avatar}
                        alt="You"
                        className="rank-avatar"
                      />
                      <span className="rank-name">John Doe (You)</span>
                    </div>
                    <span className="rank-points">
                      {rankings.find((t) => t.isCurrentUser)?.points} pts
                    </span>
                  </div>
                  <div className="ranking-motivation">
                    <p>🏆 Complete your profile to climb higher in rankings!</p>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Keep the pie-card from AnalysisSection1 */}
          <div className="analysis-card leadership-pie-card">
            <div className="chart-title">
              Keep Track of your visibility ratio to WhatsApp click.
            </div>
            <img
              src="/images/data1.png"
              alt="Pie Chart Analysis"
              className="pie-image"
            />
            <div className="analysis-icons">
              <div className="icon-container">
                <img
                  src="/images/visibility.png"
                  alt="visibility"
                  className="visibility"
                />
                <span className="icon-text">Visibility</span>
              </div>
              <div className="icon-container">
                <img
                  src="/images/whatsapp-link.png"
                  alt="whatsapp link"
                  className="whatsapp-link"
                />
                <span className="icon-text">WhatsApp Link</span>
              </div>
            </div>
          </div>
        </div>

        <div className="analysis-text">
          <img
            src="/images/tutorLogo.png"
            alt="Website Logo"
            className="tutor-logo"
          />
          <h2>Teach with Purpose</h2>
          <p>
            Join our community of passionate tutors who are making a difference
            in the lives of students worldwide. By sharing your knowledge and
            experience, you'll not only empower learners but also enhance your
            own teaching skills and confidence.{" "}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AnalysisSection2;
